const PHRASES = [
  "Peace before information",
  "Empathy without sentimentality",
  "Confidence without coldness",
  "Clinical credibility, human warmth",
  "Premium quality, genuinely accessible",
  "Clarity without oversimplifying",
];

export default function Marquee() {
  const row = (
    <>
      {PHRASES.map((p, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="text-sm sm:text-base font-medium tracking-[0.01em] text-[#F5F3EE]/85 whitespace-nowrap">{p}</span>
          <span className="mx-8 text-[#FFD400] text-xs" aria-hidden="true">✳</span>
        </span>
      ))}
    </>
  );
  return (
    <div data-testid="editorial-marquee" className="bg-[#0F0F0F] py-5 overflow-hidden" aria-hidden="true">
      <div className="flex w-max animate-marquee">
        <div className="flex shrink-0">{row}</div>
        <div className="flex shrink-0">{row}</div>
      </div>
    </div>
  );
}
